import React, { useEffect, useState } from 'react';
import { apiGet } from '../../services/apiClient';
import { Dropdown } from 'semantic-ui-react';
import { PDFReader } from 'react-read-pdf';

const InstructionsView = () => {
    const [files, setFiles] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const loadFiles = () => {
        apiGet("instructions/list")
            .then(data => {
                setFiles(data.entries || []);
            });
    };
    useEffect(loadFiles, []);

    const getFileUrl = (file) => getApiBaseUrl() + "instructions/" + file.id + "/download";

    const getVideoBrowser = (file) => {
        return (
            <video controls width="100%" height="auto">
                <source src={getFileUrl(file)} type="video/mp4" />
            </video>
        );
    };

    const getPdfBrowser = (file) => {
        return (
            <div style={{ overflow: 'scroll', height: '80vh' }}>
                <PDFReader 
                    showAllPage={true}
                    url={{ url: getFileUrl(file), withCredentials: false }}
                />
            </div>
        );
    };

    const getLinkBrowser = (file) => {
        return (
            <div>
                <h4>Для просмотра выбранного файла загрузите его по ссылке ниже:</h4>
                <a href={getFileUrl(file)}>{file.fileName}</a>
            </div>
        )
    };

    const getFileBrowser = (file) => {
        if (file.fileType === 'Video') {
            return getVideoBrowser(file);
        } else if (file.fileType === 'Pdf') {
            return getPdfBrowser(file);
        } else {
            return getLinkBrowser(file);
        }
    };

    const panesTabs = files.map((file, index) => {
        return {
            key: index,
            text: file.fileName,
            value: index
        };
    });

    const selectedFile = files && activeIndex >= 0 && activeIndex < files.length && getFileBrowser(files[activeIndex]);

    return (
        <div>
            <section className="content-header">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <h1>Инструкции</h1>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <div className="box box-primary">
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <Dropdown
                                            placeholder='Выберите инструкцию'
                                            fluid
                                            selection
                                            search
                                            options={panesTabs}
                                            value={activeIndex}
                                            onChange={(e, { value }) => setActiveIndex(value)}
                                        />
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-xs-12">
                                        {selectedFile}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default InstructionsView;


// WEBPACK FOOTER //
// ./App/pages/instructions/instructionsView.jsx